import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { PopUpNotification } from 'src/interface';

type InitialState = {
  notifications: PopUpNotification[];
};

const initialState: InitialState = {
  notifications: [],
};

export const popUpNotificationsSlice = createSlice({
  name: 'popUpNotifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<PopUpNotification>) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      const index = state.notifications.findIndex(
        ({ uuid }) => uuid === action.payload,
      );
      if (index !== -1) {
        state.notifications.splice(index, 1);
      }
    },
    clearTimeout: (state, action: PayloadAction<string>) => {
      const index = state.notifications.findIndex(
        ({ uuid }) => uuid === action.payload,
      );
      if (index !== -1) {
        state.notifications[index].timeout = null;
      }
    },
  },
});

export const { addNotification, removeNotification, clearTimeout } =
  popUpNotificationsSlice.actions;

export default popUpNotificationsSlice.reducer;
